import { RBACProvider } from '@d5/rbac'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'

import App from './App'
import { store, persistor } from './store'
import './main.css'
import '@d5/rich-text/src/index.css'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <RBACProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </RBACProvider>
    </PersistGate>
  </Provider>,
)
